import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=6d6c2b06&scoped=true&"
import script from "./ImageViewer.vue?vue&type=script&lang=js&"
export * from "./ImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&id=6d6c2b06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6c2b06",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyVideo: require('/app/components/UI/UiLazyVideo.vue').default,UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default})
